import { useCallback } from 'react';
import { useMutation } from 'convex/react';

import { api } from '../../convex/_generated/api';
import type { Id } from '../../convex/_generated/dataModel';
import { useAuth } from './useAuth';

/**
 * Convenience wrapper around `telemetry:log`.
 *
 * Silently no-ops when the user is not authenticated — telemetry is
 * scoped to a userId on the backend, so anonymous events have nowhere
 * to go.
 */
export function useTelemetry() {
  const { token } = useAuth();
  const log = useMutation(api.telemetry.log);

  return useCallback(
    async (
      event: string,
      opts?: {
        projectId?: Id<'projects'>;
        jobId?: Id<'jobs'>;
        payload?: Record<string, unknown>;
      },
    ) => {
      if (!token) return;
      try {
        await log({
          token,
          event,
          projectId: opts?.projectId,
          jobId: opts?.jobId,
          payload: opts?.payload ?? {},
        });
      } catch {
        /* never block the UI on telemetry */
      }
    },
    [token, log],
  );
}
